import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react"
import type { ReactNode, RefObject } from "react"

type Props = {
  isOpen: boolean
  onClose: () => void
  leastDestructiveRef: RefObject<HTMLButtonElement>
  title: ReactNode
  body: ReactNode
  cancelLabel?: string
  confirmLabel: string
  confirmColorScheme?: string
  confirmLoading?: boolean
  confirmDisabled?: boolean
  cancelDisabled?: boolean
  onConfirm: () => void
  isCentered?: boolean
}

export default function ActionAlertDialog({
  isOpen,
  onClose,
  leastDestructiveRef,
  title,
  body,
  cancelLabel = "Anuluj",
  confirmLabel,
  confirmColorScheme = "green",
  confirmLoading = false,
  confirmDisabled = false,
  cancelDisabled = false,
  onConfirm,
  isCentered = false,
}: Props) {
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={leastDestructiveRef}
      onClose={onClose}
      isCentered={isCentered}
      closeOnEsc={!cancelDisabled}
      closeOnOverlayClick={!cancelDisabled}
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          {title}
        </AlertDialogHeader>
        <AlertDialogBody>{body}</AlertDialogBody>
        <AlertDialogFooter>
          <Button
            ref={leastDestructiveRef}
            onClick={onClose}
            variant="outline"
            isDisabled={cancelDisabled}
          >
            {cancelLabel}
          </Button>
          <Button
            colorScheme={confirmColorScheme}
            ml={3}
            isLoading={confirmLoading}
            isDisabled={confirmDisabled}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
